<template lang="pug">
.price-data-container(@click="expand = !expand")
  .price-data
    .price-id
      span.material-symbols-outlined attach_money
      span.tag {{ data.price }}

    .price-transaction(v-if="history" :class="colorTransaction(data.transaction)") {{ data.transaction }}

    .price-date(v-if="history") {{ dateName(data.createdAt) }} - {{ time(data.createdAt) }}

  transition(name="slide-fade")
    shForm.list-price(v-if="expand && !history" :dataOriginal="data" :fillData="true" @click.native.stop="")

  transition(name="slide-fade")
    shHistory.list-price(v-if="expand && history" :dataOriginal="data" :color="colorTransaction(data.transaction)" @click.native.stop="")
</template>

<script>
import shForm from './Form'
import shHistory from './History'
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'

export default {
  name: 'Price',

  mixins: [mFilters, mForm],

  components: { shForm, shHistory },

  props: {
    data: Object,
    index: Number,
    isNew: Boolean,
    history: Boolean
  },

  data () {
    return {
      expand: false
    }
  },

  beforeDestroy () {
    this.expand = false
  }
}
</script>

<style lang="stylus">
.price-data-container
  display flex
  flex-direction row
  border-top 1px solid rgba(0, 0, 0, .2)
  padding 1.5rem 0rem
  align-items flex-start
  flex-wrap wrap
  gap 1em

.price-data
  font-size 1.2rem
  display flex
  align-items center
  cursor pointer
  flex-basis 100%
  flex-shrink 0
  text-align left
  flex-wrap wrap
  column-gap 1em

.price-id
  display flex
  align-items center
  gap .5em

.list-price
  flex-basis 100%
  flex-shrink 0
  width 100%

@media (pointer: fine)
  .price-data
    column-gap 0
    row-gap 1em

  .price-id
    width 10em
  .price-transaction
    width 8em
  .price-date
    width 10em
</style>



// WEBPACK FOOTER //
// src/components/pages/price/Price.vue